import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/landing';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
function Stars({
  size = 'h-5 w-5'
}: {
  size?: string;
}) {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-273" data-mp="3mepl0uv7xzrz">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${size} fill-[#F59E0B] text-[#F59E0B]`} aria-hidden="true" data-id="element-274" data-mp="17szyspmtij" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-16 md:py-24" data-id="element-275" data-mp="40zvbtrig3fg">
      <div className="mx-auto max-w-6xl" data-id="element-276" data-mp="91meay5oc8m1">
        <SectionHeading title="What other dental professionals are saying" data-id="element-277" data-mp="8zt81jyz3qek" />
        <div className="mt-5 flex items-center justify-center gap-3" data-id="element-278" data-mp="e0gxw2bgu177">
          <Stars size="h-6 w-6" data-id="element-279" data-mp="2au2b9ygpaozl" />
          <span className="text-2xl font-black text-navy" data-id="element-280" data-mp="2autvye8rf2b3">4.9/5</span>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-281" data-mp="2ft53ujfhv2qo">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-canvas p-6 ring-1 ring-navy/10" data-id="element-282" data-mp="1sm3vxu0ni4f4">
              <Stars data-id="element-283" data-mp="1ns9ekx8iq1j7" />
              <p className="mt-4 font-serif text-xl font-bold leading-snug text-navy" data-id="element-284" data-mp="1nrzq5e34g2fm">“{t.headline}”</p>
              <p className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-285" data-mp="1isdfnceoh0ai">“{t.body}”</p>
              <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-286" data-mp="1er1lquortswi">
                <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-sky" loading="lazy" data-id="element-287" data-mp="2bi3vpqzvec99" />
                <div data-id="element-288" data-mp="22ktg5tg0s0yj">
                  <p className="font-extrabold text-navy" data-id="element-289" data-mp="1xjm6foubgrp8">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-290" data-mp="1xjcehvppoagw">{t.country}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mt-12" data-id="element-291" data-mp="m3xj2wd5hqnw">
          <CtaButton label="I want to plan cases like this" data-id="element-292" data-mp="m2vyo1a8vrti" />
        </div>
      </div>
    </section>;
}